import { tns } from 'tiny-slider/src/tiny-slider';

export default class TinySliders {
    static init(): void {
        this.bookingSlider();
        this.bookingImageSlider();


    }

    static bookingSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-booking-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.booking-room-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.booking-room-slider__controls');

                if (sliderContainer && sliderControls) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        gutter: 10,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',

                        responsive: {
                            768: {
                                items: 2,
                                gutter: 0
                            },
                            992: {
                                items: 3,
                            }
                        },
                    });
                }
            });
        }
    }

    static bookingImageSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-booking-room-image-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.booking-room-image-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.booking-room-image-slider__controls');

                if (sliderContainer && sliderControls) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        gutter: 0,
                        loop: false,
                        mouseDrag: false,
                        preventScrollOnTouch: 'auto',
                    });
                }
            });
        }
    }
}
